import api from "@/api";
import Event from "@/types/Event";

export default class BiometryService {
  async register(
    name: string,
    document: string,
    cellphone: string,
    email: string,
    gender: string,
    birth_date: string,
    event_id: string,
  ): Promise<string> {
    const validation = [name, document, cellphone, email, gender, birth_date, event_id].every(i => typeof i === "string");

    if (!validation) throw new Error("Confira se você preencheu todos os dados do portador");

    const response = await api.post<{ data: string }>("/api/biometry/register", {
      name,
      document,
      cellphone,
      email,
      gender,
      birth_date,
      event_id,
    });

    return response.data.data;
  }

  async check(event: Event, document: string): Promise<boolean> {
    document = document.replace(/\D/g, "");

    if (document.length !== 11) throw new Error("CPF inválido");

    const response = await api.post<{ data: boolean }>(`/api/biometry/validate/${document}`, {
      event_id: event.id,
      document: document,
    });

    return response.data.data;
  }
}
